/* eslint-disable no-use-before-define */
import React, {useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import connect from "react-redux/es/connect/connect";
import PneuFabricanteDialog from "./pneuFabricanteDialog";
import PneuMedidaDialog from "./pneuMedidaDialog";
import {useSelector} from "react-redux";

const filter = createFilterOptions();

function PneuMedidaSelector({

                                onChange,
                                defaultValue

                                }) {
    const pneuMedidas  = useSelector(state =>  state.tires.medidas && state.tires.medidas.data ? state.tires.medidas.data : []);
    const [value, setValue] = React.useState(defaultValue || null);
    const [dialogOpen, setDialogOpen] = React.useState(false)
    const [dialogValue, setDialogValue] = React.useState({
        descricao: '',
        // year: '',
    });

    useEffect( () => {
        console.log('pneuMedidas.useEffect.defaultValue changed', defaultValue);
        const ix = pneuMedidas.findIndex( f => f.id === defaultValue);
        if (ix >= 0) {
            setValue(pneuMedidas[ix].descricao);
        }

        // console.log("useEffect 1", isAddNewRecord, addNewRecord, open, isOpen);
    }, [ defaultValue ]);




    return (
        <React.Fragment>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                            setDialogOpen(true);
                            setDialogValue({
                                descricao: newValue
                                // year: '',
                            });
                            onChange(newValue);
                        });
                    } else if (newValue && newValue.inputValue) {
                        setDialogOpen(true);
                        setDialogValue({
                            title: newValue.inputValue,
                            // year: '',
                        });
                        onChange(newValue);
                    } else {
                        setValue(newValue);
                        onChange(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            descricao: `Add "${params.inputValue}"`,
                        });
                    }

                    return filtered;
                }}
                id="pneuMedidas"
                options={pneuMedidas}
                getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    if (option && option.descricao) {
                        return option.descricao;
                    } else {
                        return '';
                    }
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(option) => option.descricao}
                style={{ //width: 300
                     }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label="Medida" />
                            )}
            />
            <PneuMedidaDialog open={dialogOpen}
                                  onClose={() => setDialogOpen(false)}
                                  value={dialogValue}

            />

        </React.Fragment>
);
}


export default (PneuMedidaSelector)


